class AngularMessageBusService {

	setMessageBus(msgbus) {
		this.msgbus = msgbus;
		if(!!this._onLoadCallback) {
			this._onLoadCallback(msgbus);
		}
	}

	get() {
		return this.msgbus;
	}

	_onLoadCallback(msgbus) {

	}

	onLoad(fn) {
		this._onLoadCallback = fn;
	}

}

export default AngularMessageBusService;


// WEBPACK FOOTER //
// ./resources/WEB-INF/src/angular/AngularMessageBusService.js